import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { API_PARTNERS } from "../../utils/apis";
import {
  beautify,
  createActivateAction,
  createDeactivateAction,
  createDeleteAction,
  createEditAction,
  createViewAction,
  formatDate,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_PARTNERS } from "../../utils/urls";

const url = URL_PARTNERS;

// REGISTER
export const usePartners = () => {
  const tableColumns = () => [
    { id: "partner_code", header: "Partner Code", filter: {} },
    { id: "partner_name", header: "Partner Name", filter: {} },
    { id: "partner_contact", header: "Partner Contact Name", filter: {} },
    {
      id: "partner_contact_phone",
      header: "Partner Contact Number",
      filter: {},
    },

    { id: "partner_contact_email", header: "Partner Email", filter: {} },
    {
      id: "is_active",
      header: "Status",
      filter: {
        type: "select",
        placeholder: "Select application type status...",
        options: [
          { id: "false", name: "False" },
          { id: "true", name: "True" },
        ],
      },
    },
    { id: "created_at", header: "Created At", filter: {} },
    // { id: "created_by", header: "Created By", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        partner_name: beautify(item?.partner_name),
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDate(item?.created_at),
        // created_by: beautify(item?.created_by_name),
        actions: (
          <FormActions
            actions={[
              createEditAction(url, item?.partner_code),
              createDeleteAction(
                `${API_PARTNERS}${item?.id}/`,
                `${item?.partner_name}`,
              ),
              createViewAction(url, item?.partner_code),
              ...(item?.is_active
                ? [
                    createDeactivateAction(
                      `${API_PARTNERS}${item?.partner_code}/`,
                      item?.partner_name,
                      { is_active: false },
                      {
                        showReasonField: true,
                        method: "PATCH",
                      },
                    ),
                  ]
                : [
                    createActivateAction(
                      `${API_PARTNERS}${item?.partner_code}/`,
                      item?.partner_name,
                      { is_active: true },
                      { method: "PATCH" },
                    ),
                  ]),
            ]}
          />
          // <FormActions
          //   actions={[
          //     createEditAction(url, item?.id),
          //     createDeleteAction(
          //       `${API_PARTNERS}${item?.id}/`,
          //       `${item?.partner_name}`,
          //     ),
          //     createViewAction(url, item?.id),
          //     ...(item?.is_active
          //       ? [
          //           createDeactivateAction(
          //             `${API_PARTNERS}${item?.id}/`,
          //             `${item?.partner_name}`,
          //             {
          //               is_active: false,
          //             },
          //             {
          //               showReasonField: true,
          //               method: "PATCH",
          //             },
          //           ),
          //         ]
          //       : [
          //           createActivateAction(
          //             `${API_PARTNERS}${item?.id}/`,
          //             `${item?.partner_name}`,
          //             {
          //               is_active: true,
          //             },
          //           ),
          //         ]),
          //   ]}
          // />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Partners Details",
          fields: {
            partner_code: item?.partner_code,
            partner_name: beautify(item?.partner_name),
            partner_contact: item?.partner_contact,
            partner_contact_email: item?.partner_contact_email,
            partner_contact_phone: item?.partner_contact_phone,
            Status: <BooleanTags status={item?.is_active} />,
            created_at: formatDateTime(item?.created_at),
            created_by: item?.created_by_name,
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  // const customApi = `transact/partners/list/`;

  return { tableData, tableColumns, formRoute, viewData };
};

// PARTNERS
export const usePartnersForm = ({ id }) => {
  const sections: any = [
    {
      title: "Partners Details",
      fields: [
        {
          field_name: "partner_code",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "partner_name",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "partner_contact",
          label: "Partner Contact Person",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "partner_contact_email",
          type: "text",
          label: "Partner contact email",
          props: { required: true },
        },
        {
          field_name: "charges_lumpsum",
          type: "select",
          props: { required: true },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        // {
        //   field_name: "partner_contact_phone",
        //   type: "number",
        //   props: { required: true },
        // },
        {
          field_name: "partner_contact_phone",
          type: "tel",
          label: "Partner contact phone",
          props: {
            required: true,
            // smallWidth: true,
          },
        },
        // {
        //   field_name: "is_active",
        //   type: "select",
        //   props: { required: true },
        //   options_data: [
        //     { id: true, name: "True" },
        //     { id: false, name: "False" },
        //   ],
        // },
      ],
    },
  ];

  const redirect = getRegister(url);

  const retrieveRoute = `transact/partners/list/${id}/`;

  // function onSubmit(payload: any, id: string | number) {
  //   return {
  //     api: id ? `${API_PARTNERS}/${id}` : `${API_PARTNERS}`,
  //     params: {
  //       ...payload,
  //     },
  //     method: id ? "PATCH" : "POST",
  //   };
  // }

  return { sections, redirect, retrieveRoute };
};

// SUBMIT
export function submitPartners(payload: any, id: string | number) {
  // CREATE AND UPDATE
  return {
    id,
    api: API_PARTNERS,
    params: {
      ...payload,
    },
  };
}
